import React, { useState, useEffect } from 'react';
import '../ResponsiveEvent.jsx/RequestHeader.css';
import calendaricon from '../../images/vector_x2.svg'
import axios from 'axios';
import useFormContext from "./useFormAdminContext"
import defaultBackgroundImage from "../../images/capture_decran_20240313_a_16271.jpg";
import { EVENT_COVER_URL } from '../ApiDetails.js';
import { notifyError, notifySuccess } from '../../utilities/Notification.tsx';

export default function RequestHeader() {
    const {
        eventFormData,
        setEventFormData,
        handleChange,
        handleImageUpload,
        handleUploadImageClick,
        hiddenUploadImageFileInput,
        statusHiglight,
        isCoverImageUploaded,
        setIsCoverImageUploaded
    } = useFormContext()

    const [toolTip, setToolTip] = useState({ x: 0, y: 0, text: '', isHovering: false });

    useEffect(() => {
        if (eventFormData.eventStatus != null) {
            statusHiglight(eventFormData.eventStatus);
        }
    }, [eventFormData.eventStatus]);

    // Event id is the last item in URL.
    const eventID = location.pathname.split('/').pop();

    useEffect(() => {
        const fetchEventDetails = async () => {
            var hdrDiv = document.getElementById("hdrDiv");

            await axios.get(`${EVENT_COVER_URL}/${eventID}`)
                .then(response => {
                    // Set background image based on cover image availability
                    if (response.data === '') {
                        hdrDiv.style.backgroundImage = `url(${defaultBackgroundImage})`;
                        setIsCoverImageUploaded(false);
                    } else {
                        hdrDiv.style.backgroundImage = `url(${response.data})`;
                        setIsCoverImageUploaded(true);
                    }
                })
                .catch(error => {
                    console.error("Error fetching event details:", error);
                    hdrDiv.style.backgroundImage = `url(${defaultBackgroundImage})`;
                    setIsCoverImageUploaded(false);
                });
        };

        // Don't retrieve event during creation.
        if (eventID !== "create") {
            fetchEventDetails();
        }
    }, [eventFormData.eventId]);

    const handleMouseEnter = (e, message) => {
        setToolTip({
            x: e.pageX - 10,
            y: e.pageY + 15,
            text: message,
            isHovering: true
        });
    }

    const handleMouseLeave = () => {
        setToolTip({
            isHovering: false
        });
    };

    const handleDeleteCoverImage = async () => {
        await axios.delete(`${EVENT_COVER_URL}/${eventFormData.eventId}`)
            .then(() => {
                setIsCoverImageUploaded(false);
                document.getElementById('hdrDiv').style.backgroundImage = `url(${defaultBackgroundImage})`;
                notifySuccess('Success!', 'Cover image deleted successfully.');
            })
            .catch(error => {
                console.error('Error deleting cover image:', error);
                notifyError('Oops!', 'Failed to delete cover image.');
            });
    };


    // Handle the image upload change event
    const handleImageUploadChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            // Create FormData for the POST request
            const formData = new FormData();
            formData.append("EventId", eventFormData.eventId);
            formData.append("File", file);

            try {
                const response = await axios.post(
                    EVENT_COVER_URL,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Accept: "text/plain",
                        },
                    }
                );

                if (response.data) {
                    const uploadedImageUrl = response.data;

                    var hdrDiv = document.getElementById("hdrDiv");

                    await axios.get(`${EVENT_COVER_URL}/${eventID}`)
                        .then(response => {
                            // Set background image based on cover image availability
                            if (response.data === '') {
                                hdrDiv.style.backgroundImage = `url(${defaultBackgroundImage})`;
                                setIsCoverImageUploaded(false);
                            } else {
                                hdrDiv.style.backgroundImage = `url(${response.data})`;
                                setIsCoverImageUploaded(true);

                                setEventFormData((prevData) => {
                                    const updatedData = {
                                        ...prevData,
                                        coverImage: uploadedImageUrl,
                                        IsImageCover: true,
                                    };
            
                                    return updatedData;
                                });
                            }
                        })
                        .catch(error => {
                            console.error("Error fetching event details:", error);
                            hdrDiv.style.backgroundImage = `url(${defaultBackgroundImage})`;
                            setIsCoverImageUploaded(false);
                        });
                }
                setIsCoverImageUploaded(true);
            } catch (error) {
                console.error(
                    "Error uploading cover image:",
                    error.response || error.message
                );
            }
        }
    };

    return (
        <div className="requestHeader">
            <div className="container-fluid">
                <div id='hdrDiv' className="bd-placeholder-img custom-jumbotron jumbotron p-6 mt-3 p-md-3 text-white rounded mb-2 d-flex flex-column justify-content-end m-4" >
                    <div className="row bottom-row ml-2 mr-2">
                        <div className="col-12 col-md-8 p-2 px-0 bg-light rounded mb-5 mb-md-0 ">
                            <div className="content">
                                <h6>
                                    <input
                                        type="text"
                                        readOnly={true}
                                        className="custom-title form-control-plaintext disabled"
                                        id="staticEmail"
                                        name="eventTitle"
                                        value={eventFormData.eventTitle}

                                        placeholder="Click here to modify the event"
                                        style={{ backgroundColor: 'white !important', fontWeight: 'bold !important', fontSize: '60% !important' }}
                                    />
                                </h6>
                                <p>
                                    <strong>
                                        <img src={calendaricon} height='12px' />
                                    </strong>
                                    <span className='m-1'> <strong>Event date:  </strong> {new Date(eventFormData.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}</span>

                                </p>
                                <span>Status</span>
                                <div className="breadcrumb btn-group btn-breadcrumb rounded" id="eventStatusTab">
                                    <a className="btn-custom btn btn-default selectbreadcrumb" id="Draft" style={{ pointerEvents: "none" }}>Draft</a>
                                    {(eventFormData.mltEvent === false || eventFormData.mltEvent === null) && (
                                        <><a className="btn-custom btn btn-default" id="UnderReview" style={{ pointerEvents: "none" }}>Under Review</a></>
                                    )}
                                    {(eventFormData.eventStatus === "Cancelled") && (
                                        <><a className="btn-custom btn btn-default" id="Cancelled" style={{ pointerEvents: "none" }}>Cancelled</a></>
                                    )}
                                    {(eventFormData.eventStatus === "Rejected") && (
                                        <><a className="btn-custom btn btn-default" id="Rejected" style={{ pointerEvents: "none" }}>Rejected</a></>
                                    )}
                                    {(eventFormData.eventStatus != "Cancelled") && (eventFormData.eventStatus != "Rejected") && (
                                        <>
                                            <a className="btn-custom btn btn-default" id="OpenEvent" style={{ pointerEvents: "none" }}>Open Event</a>
                                            <a className="btn-custom btn btn-default" id="AttendanceConfirmed" style={{ pointerEvents: "none" }}>Attendance confirmed</a>
                                            <a className="btn-custom btn btn-default" id="PendingDocumentation" style={{ pointerEvents: "none" }}>Pending documentation</a>
                                            <a className="btn-custom btn btn-default" id="Completed" style={{ pointerEvents: "none" }}>Completed</a>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 px-0 position-relative">
                            <div className=" p-3 position-relative" style={{ height: "100%" }}>
                                <div className="bg-white rounded p-3 position-absolute bottom-0 end-0">
                                    {isCoverImageUploaded ? (
                                        <button
                                            type="button"
                                            className="btn-custom btn btn-outline-danger"
                                            onClick={handleDeleteCoverImage}
                                            onMouseEnter={(e) => handleMouseEnter(e, "Delete the loaded image here")}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <strong>DELETE EXISTING COVER IMAGE</strong>
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            id="coverImageUpload"
                                            className="btn-custom btn btn-outline-primary"
                                            onClick={handleUploadImageClick}
                                            onMouseEnter={(e) => handleMouseEnter(e, "Please load picture of your factory/site here")}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <strong>UPLOAD COVER IMAGE</strong>
                                        </button>
                                    )}
                                    <input
                                        type="file"
                                        name="imageFile"
                                        onChange={(e) => eventFormData.eventId == 0 ?
                                            (handleChange(e),
                                                handleImageUpload(e)) :
                                            (handleChange(e),
                                                handleImageUploadChange(e))
                                        }
                                        ref={hiddenUploadImageFileInput}
                                        style={{ display: 'none' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {toolTip.isHovering &&
                    (
                        <div className="tooltip-image"
                            style={{
                                backgroundColor: '#021354',
                                top: `${toolTip.y}px`,
                                left: `${toolTip.x}px`
                            }}
                        >
                            <span>{toolTip.text}</span>
                        </div>
                    )
                }
            </div>
        </div>
    );
}